<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <el-container style="height:650px;">
      <el-header style="padding:0px;margin:0px;">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="查看审批流程" name="approvalList">
            <approvalList @setTab="setTab"></approvalList>
          </el-tab-pane>
          <el-tab-pane label="审批流程设置" name="approvalEdit">
            <approvalEdit @setTab="setTab" :flow-id="flowId"></approvalEdit>
          </el-tab-pane>
        </el-tabs>
      </el-header>
    </el-container>
  </div>
</template>
<script>
import approvalList from "@/views/attendanceSystem/attendanceApply/approvalList";
import approvalEdit from "@/views/attendanceSystem/attendanceApply/approvalEdit";
import breadcrumb from "@/components/common/breadcrumb";
export default {
  name: "",
  components: {
    breadcrumb,
    approvalList,
    approvalEdit
  },
  data() {
    return {
      entpId: this.$util.getLocalStorage("userMsg").EntpId,
      activeName: "approvalList",
      flowId: ""
    };
  },
  created() {},
  mounted() {},
  methods: {
    handleClick(tab, event) {},
    //子控制父跳转
    setTab(name, rowId) {
      this.activeName = name;
      if (rowId) {
        this.flowId = rowId;
      }
    }
  }
};
</script>
<style lang="less" scoped>
</style>
